export const SUBSCRIPTIONS_PUBLIC_CONTROLLER_ROOT_PATH = "/subscriptions";
